/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Team } from '../../models/team';
import { TeamMembersToRemove } from '../../models/team-members-to-remove';

export interface RemoveTeamMembersInOrgApiV2SecretariatMembersOrgIdTeamsDelete$Params {
  orgId: string;
  org: string;
      body: TeamMembersToRemove
}

export function removeTeamMembersInOrgApiV2SecretariatMembersOrgIdTeamsDelete(http: HttpClient, rootUrl: string, params: RemoveTeamMembersInOrgApiV2SecretariatMembersOrgIdTeamsDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<Team>>> {
  const rb = new RequestBuilder(rootUrl, removeTeamMembersInOrgApiV2SecretariatMembersOrgIdTeamsDelete.PATH, 'delete');
  if (params) {
    rb.path('orgId', params.orgId, {});
    rb.query('org', params.org, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<Team>>;
    })
  );
}

removeTeamMembersInOrgApiV2SecretariatMembersOrgIdTeamsDelete.PATH = '/api/v2/secretariat/members/{orgId}/teams';
